import {Link, NavLink} from "react-router-dom";
import {Fragment} from "react";
import {urlDynamic} from "../../../settings/utils/urlDynamic";

export const footer = (home = false) => {
    return (
        <Fragment>
            <div className='row py-lg-5 cBg1 justify-content-center cPx1 cZindex9995'>
                <div className='cContainer col-12'>
                    <div className='row text-center text-white'>
                        <div className='col-12 col-lg-4 cBorder4 py-3 py-lg-0'>
                            <NavLink to={urlDynamic.path.homeFa}>
                                <img src='/images/logo.webp' width='250' height='66' className='img-fluid' alt='تصویر'/>
                            </NavLink>
                            {home === true ? (
                                <h1 className='cLineHeight1 cFontSize14 mb-0 mt-3 cJustify2 px-lg-4'>مرکز ملی تحقیقات
                                    راهبردی آموزش علوم پزشکی (نصر) با هدف ارتقای آموزش علوم پزشکی، ترویج سیاستگذاری
                                    مبتنی بر شواهد، توسعه پژوهش‌های راهبردی، حمایت از طرح‌های نوآورانه و مشارکت ملی و
                                    بین‌المللی فعالیت می‌کند</h1>
                            ) : (
                                <p className='cLineHeight1 mt-3 mb-0 cFontSize14 cJustify2 px-lg-4'>مرکز ملی تحقیقات
                                    راهبردی آموزش علوم پزشکی (نصر) با هدف ارتقای آموزش علوم پزشکی، ترویج سیاستگذاری
                                    مبتنی بر شواهد، توسعه پژوهش‌های راهبردی، حمایت از طرح‌های نوآورانه و مشارکت ملی و
                                    بین‌المللی فعالیت می‌کند</p>
                            )}
                        </div>
                        <div className='col-12 col-lg-4 cBorder4 py-3 py-lg-0'>
                            <h2 className='fw-bold cFontSize20 mb-3'>آدرس</h2>
                            <p className='lh-lg mb-2'>تهران، خیابان ولیعصر (عج) بعد از چهار راه آیت ا..
                                هاشمی رفسنجانی، خیابان سعیدی، پلاک ۶۵</p>
                            <p className='lh-lg mb-2'>کد پستی: ۱۹۶۷۸۴۶۹۱۱</p>
                            <p className='lh-lg mb-2'>شماره تلفن: ۷۵۴۸۴۰۰- ۰۲۱</p>
                            <p className='lh-lg mb-2'>شماره فکس: ۲۶۲۹۲۴۸- ۰۲۱</p>
                            <p className='lh-lg mb-2'>پست الکترونیک: nasr@nasrme.ac.ir</p>
                        </div>
                        <div className='col-12 col-lg-4 py-3 py-lg-0'>
                            <h2 className='fw-bold cFontSize20 mb-3'>لینک های مفید</h2>
                            <Link to='https://behdasht.gov.ir/' target='_blank'
                                  className='d-inline-block lh-lg mb-2 text-white '>وزارت
                                بهداشت، درمان و آموزش پزشکی
                                <svg stroke="currentColor" fill="currentColor"
                                     strokeWidth="0" viewBox="0 0 16 16"
                                     className="text-main-color ms-1"
                                     height="1em"
                                     width="1em"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path>
                                </svg>


                            </Link>
                            <div></div>
                            <Link to='https://dme.behdasht.gov.ir/' target='_blank'
                                  className='d-inline-block lh-lg mb-2 text-white'>معاونت
                                آموزشی
                                <svg stroke="currentColor" fill="currentColor"
                                     strokeWidth="0" viewBox="0 0 16 16"
                                     className="text-main-color ms-1"
                                     height="1em"
                                     width="1em"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path>
                                </svg>


                            </Link>
                            <div></div>
                            <Link to='https://rms.nimad.ac.ir/' target='_blank'
                                  className='d-inline-block text-white  lh-lg mb-2'>معاونت تحقیقات
                                <svg stroke="currentColor" fill="currentColor"
                                     strokeWidth="0" viewBox="0 0 16 16"
                                     className="text-main-color ms-1"
                                     height="1em"
                                     width="1em"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path>
                                </svg>


                            </Link>
                            <div></div>
                            <Link to='https://www.msrt.ir' target='_blank'
                                  className='d-inline-block text-white lh-lg mb-2'>وزارت
                                علوم، تحقیقات و فناوری
                                <svg stroke="currentColor" fill="currentColor"
                                     strokeWidth="0" viewBox="0 0 16 16"
                                     className="text-main-color ms-1"
                                     height="1em"
                                     width="1em"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        fillRule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path>
                                </svg>


                            </Link>
                            <div></div>
                            <Link to='https://ble.ir/nasrme' target='_blank'
      className='d-inline-block text-white lh-lg mb-2'>
    کانال بله
    <svg stroke="currentColor" fill="currentColor"
         strokeWidth="0" viewBox="0 0 16 16"
         className="text-main-color ms-1"
         height="1em"
         width="1em"
         xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"></path>
    </svg>
</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row cBg1 justify-content-center cPx1'>
                <div className='cContainer col-12 cBorder5 py-2'>
                    <div className='row justify-content-center text-center text-white'>
                        <div className='col-12'>
                            <p className='mb-0 text-white lh-lg'>تمامی حقوق مالکیت معنوی این وب سایت برای
                                مرکز نصر محفوظ است</p>
                        </div>
                    </div>
                </div>
            </div>













        </Fragment>
    )
}